import { Scene, TimerEvent } from '@Core/Scene/Scene';
import { DeferredPromise } from '@Tools/DeferredPromise';

export class WinPresentationPromises {
    public readonly winStarted = new DeferredPromise();
    public readonly winHidden = new DeferredPromise();
    public readonly betSaved = new DeferredPromise();
    public readonly skipTriggered = new DeferredPromise();
    public readonly timerElapsed = new DeferredPromise();

    private currentTimer?: TimerEvent;

    constructor(private readonly scene: Scene) {}

    public startTimer(duration: number) {
        this.currentTimer ? this.currentTimer.destroy() : this.timerElapsed.reset();
        this.currentTimer = this.scene.time.delayedCall(duration, () => this.timerElapsed.resolve());
    }

    public stopTimer() {
        this.currentTimer?.destroy();
        this.timerElapsed.reset();
    }
}
